import { signOut } from 'aws-amplify/auth'
import { USER_ID_TOKEN } from '@/common/constants'
import {
    SIX_DEVICE_AUTH_VERIFIED,
    SIX_DEVICE_AUTH_ATTEMPTED,
    SIX_DEVICE_AUTH_LAST_ACTIVITY_TS,
    SIX_LOCAL_PREFIX,
    SIX_SESSION_PREFIX,
} from '@/common/storage/keys'

type Options = {
    redirect?: boolean
    clearStorage?: boolean
}

export async function performManualSignOut({ redirect = false, clearStorage = true }: Options = {}) {
    try {
        await signOut()
    } catch {
        // ignore
    }

    if (clearStorage) {
        try {
            // Clear app-specific localStorage keys
            Object.keys(localStorage)
                .filter(
                    (key) =>
                        key.startsWith('CognitoIdentityServiceProvider') ||
                        key.startsWith('aws-amplify') ||
                        key.startsWith('Amplify.Auth') ||
                        key.includes('CognitoIdentity') ||
                        key.startsWith(SIX_LOCAL_PREFIX) ||
                        key.startsWith(SIX_SESSION_PREFIX) ||
                        key.includes('user') ||
                        key.includes('token') ||
                        key.includes('session'),
                )
                .forEach((key) => localStorage.removeItem(key))
        } catch {
            // ignore
        }

        try {
            sessionStorage.removeItem(USER_ID_TOKEN)
            sessionStorage.removeItem(SIX_DEVICE_AUTH_VERIFIED)
            sessionStorage.removeItem(SIX_DEVICE_AUTH_ATTEMPTED)
            sessionStorage.removeItem(SIX_DEVICE_AUTH_LAST_ACTIVITY_TS)
        } catch {
            // ignore
        }
    }

    if (redirect) {
        try {
            window.location.href = '/'
        } catch {
            // ignore
        }
    }
}

export default performManualSignOut
